// https://ponyfoo.com/articles/binding-methods-to-class-instance-objects

export const selfish = <T extends object>(target: T) => {
    const cache = new WeakMap();

    const handler: ProxyHandler<T> = {
        get(target: T, key) {
            const value = Reflect.get(target, key);
            if (typeof value !== 'function') {
                return value;
            }
            if (!cache.has(value)) {
                cache.set(value, value.bind(target));
            }
            return cache.get(value);
        },
    };

    return new Proxy<T>(target, handler);
};
